import React, { useRef, useEffect, useMemo } from "react";
import * as d3 from "d3";

import { number, array, func } from "prop-types";

const propTypes = {
  width: number,
  chartValues: array.isRequired,
  handleClick: func.isRequired,
};

const FundingGraph = (props) => {
  const { width, chartValues, handleClick } = props;

  const height = useMemo(() => width, [width]);

  const d3Container = useRef(null);

  useEffect(() => {
    if (chartValues && d3Container.current) {
      const radius = width / 2 - 40;

      const pie = d3
        .pie()
        .value((d) => d.value)
        .sort(null);

      const arc = d3
        .arc()
        .innerRadius(radius * 0.75)
        .outerRadius(radius);

      const g = d3.select(d3Container.current);

      let arcs = g
        .selectAll(".funding-interactive__arc")
        .data(pie(chartValues));

      const arcsEnter = arcs
        .enter()
        .append("g")
        .attr("class", "funding-interactive__arc");

      const arcsExit = arcs.exit().remove();

      arcsEnter.append("path").attr("class", "funding-interactive__path");

      arcsEnter.append("text");

      arcs = arcsEnter.merge(arcs);

      arcs.on("click", (d) => {
        try {
          handleClick(d.data.index);
        } catch (err) {
          //no callback
        }
      });

      const path = arcs
        .select("path")
        .attr("d", arc)
        .attr("fill", (d) => d.data.color);

      const text = arcs
        .select("text")
        .attr("aria-hidden", true)
        .attr("transform", function (d) {
          var c = arc.centroid(d),
            x = c[0],
            y = c[1],
            // pythagorean theorem for hypotenuse
            h = Math.sqrt(x * x + y * y);
          return (
            "translate(" +
            (x / h) * (radius + 20) +
            "," +
            (y / h) * (radius + 20) +
            ")"
          );
        })
        .attr("text-anchor", (d) => {
          // are we past the center?
          return (d.endAngle + d.startAngle) / 2 > Math.PI ? "end" : "start";
        })
        .text((d) => d.data.label);
    }
  }, [chartValues, width, handleClick]);

  return (
    <svg
      className="funding-interactive__svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
    >
      <g
        style={{ transform: "translate(50%,50%)" }}
        ref={d3Container}
        className="funding-interactive__main-g"
      ></g>
    </svg>
  );
};

FundingGraph.propTypes = propTypes;
export default FundingGraph;
